module.exports = __webpack_public_path__ + "static/media/Shridhar.f3bb19d2.jpeg";